import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import AndroidDashboardPage from './pages/GoLiveAndroidDashboardPage';
import AndroidDashboardPagev2 from './pages/GoLiveAndroidDashboardPage';
import Daily from './pages/DailyStatsDashboard'
import OmegoAndroid from './pages/omego/OmegoAndroidDashboard'
import Wow from './pages/wow/OmegoAndroidDashboard'

import WEB from './pages/web/GoLiveAndroidDashboardPage'
import YESS from './pages/yess/GoLiveAndroidDashboardPage'
import CleepAiLp2 from './pages/cleep-ai-lp2/GoLiveAndroidDashboardPage'
import UniversalDashboard from './pages/universal/GoLiveAndroidDashboardPage'
import UniversalAdsetsDashboard from './pages/universal/AdsetsDashboardPage'
import UniversalAdsDashboard from './pages/universal/AdsDashboardPage'

const App: React.FC = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/db/:dbName" element={<UniversalDashboard />} />
        <Route path="/db/:dbName/adsets" element={<UniversalAdsetsDashboard />} />
        <Route path="/db/:dbName/ads" element={<UniversalAdsDashboard />} />
        <Route path="/android-dashboard" element={<AndroidDashboardPage />} />
        <Route path="/android-omego-dashboard" element={<OmegoAndroid />} />
        <Route path="/android-dashboard-v2" element={<AndroidDashboardPagev2 />} />
        <Route path="/android-dashboardv2" element={<Daily />} />
        <Route path="/wow" element={<Wow />} />

        <Route path="/web" element={<WEB />} />
        <Route path="/yess" element={<YESS />} />
        <Route path="/cleep-ai-lp2" element={<CleepAiLp2 />} />
      </Routes>
    </Router>
  );
};

export default App;